import { getPathnameFromPathSegments } from './getPathnameFromPathSegments';
import { getPathSegmentsFromPathname } from './getPathSegmentsFromPathname';

/**
 * @example
 * `{ route: '/signup/me', cardName: 'me1' }` returns `/signup/me/me1`
 * `{ route: '/signup/pets', cardName: 'petWeight', petName: 'fido' }` returns `/signup/pets/fido/petWeight`
 */
export function getSignupRouteFromDetails({
  route,
  cardName,
  petName,
}: {
  route: string;
  cardName: string;
  petName?: string;
}) {
  const pathSegments = getPathSegmentsFromPathname(route);

  // pathSegments[0] is always "signup"
  const isPetRoute = pathSegments[1] === 'pets';

  if (isPetRoute && petName) {
    pathSegments.push(petName);
  }

  pathSegments.push(cardName);

  return getPathnameFromPathSegments(pathSegments);
}
